<template>
    <div>
        <draggable-accordion
            class="mb-2"
            v-for="content in props.data.contents"
            :unique_id="content.unique_id"
            :edit="content.edit"
            @remove="removeContent"
            @toggle="toggleContent(content)"
        >
            <template #title>{{ contentName }}</template>

        </draggable-accordion>
    </div>

    <div class="flex justify-between items-center">
        <div class="flex justify-between items-center">
            <toggle
                name="columns_toggle"
                size="medium"
                v-model="data.display_blocks_in_columns"
            />
            <span class="flex flex-col flex-grow" id="columns_toggle-label">
                    <span class="text-sm text-gray-900">Display blocks in columns</span>
                </span>
        </div>
    </div>

</template>

<script setup>
import {defineProps} from 'vue';
import {uniqueId} from '../helpers';

const contentName = 'AvailableRewards';

const props = defineProps({
    data: Object
});

props.data.contents = props.data?.contents ?? [];

// Ensure only one content is open at initialization
let foundFirstOpen = false;
props.data.contents.forEach(content => {
    if (content.edit) {
        if (foundFirstOpen) {
            content.edit = false;
        } else {
            foundFirstOpen = true;
        }
    }
});

const toggleContent = (element) => {
    const isOpening = !element.edit;
    if (isOpening) {
        props.data.contents.forEach(content => {
            if (content.unique_id !== element.unique_id) {
                content.edit = false;
            }
        });
    }
    element.edit = !element.edit;
}

const addContent = () => {
    // Close all existing content
    props.data.contents.forEach(content => {
        content.edit = false;
    });
    
    props.data.contents.push({
        unique_id: uniqueId(),
        edit: true,
        text: '',
    });
}

const removeContent = (uniqueId) => {
    props.data.contents.splice(
        props.data.contents.findIndex(content => content.unique_id === uniqueId)
    , 1);
}
</script>
